export default __webpack_public_path__ + "static/media/zakir.df2ee5d7.jpeg";